import React from "react";
import {Icon} from "antd";
import {WechatCodeLoginFormProps, withWechatCodeLoginForm} from "../../hoc/withWechatCodeLoginForm";
import CountDownButton from "../CountDownButton";
import {useIntl} from "react-intl";

const BasWechatCodeLogin: React.FC<WechatCodeLoginFormProps> = (props) => {
    const {username, code, changeUsername, changeCode, loginLoading, sendCode} = props
    let intl = useIntl();
    return (
        <>
            <div className={'input'}>
                <Icon type="user" />
                <input
                    placeholder={intl.formatMessage({id: "用户名"})}
                    value={username}
                    onChange={changeUsername}
                />
            </div>
            <div className={'input'}>
                <Icon type="wechat" />
                <input
                    placeholder={intl.formatMessage({id: "微信验证码"})}
                    value={code}
                    onChange={changeCode}
                />
                <CountDownButton onClick={sendCode} text={intl.formatMessage({id: "发送"})} style={{whiteSpace: 'nowrap'}} />
            </div>
            <button type="submit" className={'submit'} disabled={loginLoading}>
                {loginLoading ? <Icon type="loading" /> : ''}{intl.formatMessage({id: "登 录"})}
            </button>
        </>
    )
}

export default withWechatCodeLoginForm(BasWechatCodeLogin)
